
// @ts-nocheck


export const localeCodes =  [
  "ar",
  "bg",
  "bn",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fi",
  "fr",
  "hi",
  "hu",
  "id",
  "it",
  "ja",
  "ko",
  "lt",
  "lv",
  "nb",
  "nl",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sv",
  "sw",
  "tr",
  "uk",
  "vi",
  "zh"
]

export const localeLoaders = {
  "ar": [],
  "bg": [],
  "bn": [],
  "cs": [],
  "da": [],
  "de": [],
  "el": [],
  "en": [],
  "es": [],
  "et": [],
  "fi": [],
  "fr": [],
  "hi": [],
  "hu": [],
  "id": [],
  "it": [],
  "ja": [],
  "ko": [],
  "lt": [],
  "lv": [],
  "nb": [],
  "nl": [],
  "pl": [],
  "pt": [],
  "ro": [],
  "ru": [],
  "sk": [],
  "sl": [],
  "sv": [],
  "sw": [],
  "tr": [],
  "uk": [],
  "vi": [],
  "zh": []
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "ar",
      "language": "ar-SA",
      "name": "العربية"
    },
    {
      "code": "bg",
      "language": "bg-BG",
      "name": "Български"
    },
    {
      "code": "bn",
      "language": "bn-BD",
      "name": "বাংলা"
    },
    {
      "code": "cs",
      "language": "cs-CZ",
      "name": "Čeština"
    },
    {
      "code": "da",
      "language": "da-DK",
      "name": "Dansk"
    },
    {
      "code": "de",
      "language": "de-DE",
      "name": "Deutsch"
    },
    {
      "code": "el",
      "language": "el-GR",
      "name": "Ελληνικά"
    },
    {
      "code": "en",
      "language": "en-US",
      "name": "English"
    },
    {
      "code": "es",
      "language": "es-ES",
      "name": "Español"
    },
    {
      "code": "et",
      "language": "et-EE",
      "name": "Eesti"
    },
    {
      "code": "fi",
      "language": "fi-FI",
      "name": "Suomi"
    },
    {
      "code": "fr",
      "language": "fr-FR",
      "name": "Français"
    },
    {
      "code": "hi",
      "language": "hi-IN",
      "name": "हिन्दी"
    },
    {
      "code": "hu",
      "language": "hu-HU",
      "name": "Magyar"
    },
    {
      "code": "id",
      "language": "id-ID",
      "name": "Bahasa Indonesia"
    },
    {
      "code": "it",
      "language": "it-IT",
      "name": "Italiano"
    },
    {
      "code": "ja",
      "language": "ja-JP",
      "name": "日本語"
    },
    {
      "code": "ko",
      "language": "ko-KR",
      "name": "한국어"
    },
    {
      "code": "lt",
      "language": "lt-LT",
      "name": "Lietuvių"
    },
    {
      "code": "lv",
      "language": "lv-LV",
      "name": "Latviešu"
    },
    {
      "code": "nb",
      "language": "nb-NO",
      "name": "Norsk"
    },
    {
      "code": "nl",
      "language": "nl-NL",
      "name": "Nederlands"
    },
    {
      "code": "pl",
      "language": "pl-PL",
      "name": "Polski"
    },
    {
      "code": "pt",
      "language": "pt-PT",
      "name": "Português"
    },
    {
      "code": "ro",
      "language": "ro-RO",
      "name": "Română"
    },
    {
      "code": "ru",
      "language": "ru-RU",
      "name": "Русский"
    },
    {
      "code": "sk",
      "language": "sk-SK",
      "name": "Slovenčina"
    },
    {
      "code": "sl",
      "language": "sl-SI",
      "name": "Slovenščina"
    },
    {
      "code": "sv",
      "language": "sv-SE",
      "name": "Svenska"
    },
    {
      "code": "sw",
      "language": "sw-KE",
      "name": "Kiswahili"
    },
    {
      "code": "tr",
      "language": "tr-TR",
      "name": "Türkçe"
    },
    {
      "code": "uk",
      "language": "uk-UA",
      "name": "Українська"
    },
    {
      "code": "vi",
      "language": "vi-VN",
      "name": "Tiếng Việt"
    },
    {
      "code": "zh",
      "language": "zh-CN",
      "name": "中文"
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": true,
  "langDir": null,
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ar",
    "language": "ar-SA",
    "name": "العربية",
    "files": []
  },
  {
    "code": "bg",
    "language": "bg-BG",
    "name": "Български",
    "files": []
  },
  {
    "code": "bn",
    "language": "bn-BD",
    "name": "বাংলা",
    "files": []
  },
  {
    "code": "cs",
    "language": "cs-CZ",
    "name": "Čeština",
    "files": []
  },
  {
    "code": "da",
    "language": "da-DK",
    "name": "Dansk",
    "files": []
  },
  {
    "code": "de",
    "language": "de-DE",
    "name": "Deutsch",
    "files": []
  },
  {
    "code": "el",
    "language": "el-GR",
    "name": "Ελληνικά",
    "files": []
  },
  {
    "code": "en",
    "language": "en-US",
    "name": "English",
    "files": []
  },
  {
    "code": "es",
    "language": "es-ES",
    "name": "Español",
    "files": []
  },
  {
    "code": "et",
    "language": "et-EE",
    "name": "Eesti",
    "files": []
  },
  {
    "code": "fi",
    "language": "fi-FI",
    "name": "Suomi",
    "files": []
  },
  {
    "code": "fr",
    "language": "fr-FR",
    "name": "Français",
    "files": []
  },
  {
    "code": "hi",
    "language": "hi-IN",
    "name": "हिन्दी",
    "files": []
  },
  {
    "code": "hu",
    "language": "hu-HU",
    "name": "Magyar",
    "files": []
  },
  {
    "code": "id",
    "language": "id-ID",
    "name": "Bahasa Indonesia",
    "files": []
  },
  {
    "code": "it",
    "language": "it-IT",
    "name": "Italiano",
    "files": []
  },
  {
    "code": "ja",
    "language": "ja-JP",
    "name": "日本語",
    "files": []
  },
  {
    "code": "ko",
    "language": "ko-KR",
    "name": "한국어",
    "files": []
  },
  {
    "code": "lt",
    "language": "lt-LT",
    "name": "Lietuvių",
    "files": []
  },
  {
    "code": "lv",
    "language": "lv-LV",
    "name": "Latviešu",
    "files": []
  },
  {
    "code": "nb",
    "language": "nb-NO",
    "name": "Norsk",
    "files": []
  },
  {
    "code": "nl",
    "language": "nl-NL",
    "name": "Nederlands",
    "files": []
  },
  {
    "code": "pl",
    "language": "pl-PL",
    "name": "Polski",
    "files": []
  },
  {
    "code": "pt",
    "language": "pt-PT",
    "name": "Português",
    "files": []
  },
  {
    "code": "ro",
    "language": "ro-RO",
    "name": "Română",
    "files": []
  },
  {
    "code": "ru",
    "language": "ru-RU",
    "name": "Русский",
    "files": []
  },
  {
    "code": "sk",
    "language": "sk-SK",
    "name": "Slovenčina",
    "files": []
  },
  {
    "code": "sl",
    "language": "sl-SI",
    "name": "Slovenščina",
    "files": []
  },
  {
    "code": "sv",
    "language": "sv-SE",
    "name": "Svenska",
    "files": []
  },
  {
    "code": "sw",
    "language": "sw-KE",
    "name": "Kiswahili",
    "files": []
  },
  {
    "code": "tr",
    "language": "tr-TR",
    "name": "Türkçe",
    "files": []
  },
  {
    "code": "uk",
    "language": "uk-UA",
    "name": "Українська",
    "files": []
  },
  {
    "code": "vi",
    "language": "vi-VN",
    "name": "Tiếng Việt",
    "files": []
  },
  {
    "code": "zh",
    "language": "zh-CN",
    "name": "中文",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
